import { Style, InputType, Preconditions, DynamicUpdateAction, DynamicUpdateCondition } from 'common/questionnaires/types';
import helpText from 'common/questionnaires/helpText';

const w9Questions = [
  {
    id: 'W9.NAME.1',
    name: 'name',
    info: helpText.name,
    questionText: 'preQualifyingQuestionnaire.W9.NAME.1.questionText',
    style: Style.Card,
    group: 'Name',
    answer: 'CUSTOMER-NAME',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Full Name', required: true }
      ]
    },
    errorMessage: 'Please provide a full name.'
  }, {
    id: 'W9.NAME.2',
    name: 'businessname',
    info: helpText.disregardedEntity,
    questionText: 'preQualifyingQuestionnaire.W9.NAME.2.questionText',
    style: Style.Embedded,
    group: 'Name',
    answer: 'DRE-NAME',
    preconditions: [Preconditions.CustomerRecordNameIsDRE],
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Business Name/Disregarded Entity Name', required: false }
      ]
    }
  }, {
    id: 'W9.ADDRESS.1',
    name: 'addressline1',
    info: helpText.residenceAddress,
    questionText: 'preQualifyingQuestionnaire.W9.ADDRESS.1.questionText',
    style: Style.Card,
    group: 'Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Street Address', required: true }
      ]
    },
    errorMessage: 'Please provide a street address.'
  }, {
    id: 'W9.ADDRESS.2',
    name: 'citystateprovince',
    style: Style.Embedded,
    group: 'Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'City, State - e.g. Washington, DC', required: true }
      ]
    },
    errorMessage: 'Please provide a city, state, province, or territory.'
  }, {
    id: 'W9.ADDRESS.3',
    name: 'country',
    style: Style.Embedded,
    group: 'Address',
    inputs: {
      type: InputType.CountryDropdown,
      invalidSelection: 'Please Select Country',
      defaultValue: { value: 'United States of America', label: 'United States of America' }
    },
    errorMessage: 'Please provide a country.'
  }, {
    id: 'W9.ADDRESS.4',
    name: 'postalcode',
    style: Style.Embedded,
    group: 'Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Zip Code', required: false }
      ]
    }
  }, {
    id: 'W9.FTC.1',
    name: 'federaltaxclassification',
    questionText: 'preQualifyingQuestionnaire.W9.FTC.1.questionText',
    style: Style.Card,
    group: 'Federal Tax Classification',
    preconditions: [Preconditions.CustomerRecordNameIsIndividual, Preconditions.LegalOrSoleOwnerIsIndividual],
    answer: '1',
    isAnswered: true,
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { label: 'Individual/sole proprietor or single-member LLC', value: '1' },
      items: [
        { value: 1, label: 'Individual/sole proprietor or single-member LLC' },
        { value: 2, label: 'C Corporation' },
        { value: 3, label: 'S Corporation' },
        { value: 4, label: 'Partnership' },
        { value: 5, label: 'Trust/estate' },
        { value: 6, label: 'Limited liability company' },
        { value: 7, label: 'Other' },
      ]
    },
    errorMessage: 'Required: "Please provide a federal tax classification.'
  }, {
    id: 'W9.FTC.2',
    name: 'federaltaxclassificationLlc',
    questionText: 'preQualifyingQuestionnaire.W9.FTC.2.questionText',
    style: Style.Embedded,
    group: 'Federal Tax Classification',
    dynamicUpdate: {
      inputQuestionId: 'W9.FTC.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: '6',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      invalidSelection: 'Please Select',
      items: [
        { value: 0, label: 'Please Select' },
        { value: 1, label: 'C Corporation' },
        { value: 2, label: 'S Corporation' },
        { value: 3, label: 'Partnership' },
      ]
    },
    errorMessage: 'Please provide the federal tax classification of the limited liability company.'
  }, {
    id: 'W9.FTC.3',
    name: 'federaltaxclassificationOther',
    questionText: 'preQualifyingQuestionnaire.W9.FTC.3.questionText',
    style: Style.Embedded,
    group: 'Federal Tax Classification',
    dynamicUpdate: {
      inputQuestionId: 'W9.FTC.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: '7',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Federal Tax Classification', required: true }
      ]
    },
    errorMessage: 'Please type the federal tax classification.'
  }, {
    id: 'W9.Exemptions.1',
    name: 'epayeecode',
    info: helpText.exemptPayeeCode,
    questionText: 'preQualifyingQuestionnaire.W9.Exemptions.1.questionText',
    style: Style.Card,
    group: 'Exemptions',
    preconditions: [Preconditions.CustomerRecordNameIsIndividual, Preconditions.LegalOrSoleOwnerIsIndividual],
    inputs: {
      type: InputType.Dropdown,
      showSelected: false,
      defaultValue: { value: 'NA', label: 'Not Applicable' },
      items: [
        { value: 'NA', label: 'Not Applicable' },
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
        { value: 11, label: '11' },
        { value: 12, label: '12' },
        { value: 13, label: '13' },
      ]
    }
  }, {
    id: 'W9.Exemptions.2',
    name: 'efatcareportingcode',
    info: helpText.exemptionFatcaReportingCode,
    questionText: 'preQualifyingQuestionnaire.W9.Exemptions.2.questionText',
    style: Style.Embedded,
    group: 'Exemptions',
    preconditions: [Preconditions.CustomerRecordNameIsIndividual, Preconditions.LegalOrSoleOwnerIsIndividual],
    inputs: {
      type: InputType.Dropdown,
      showSelected: false,
      defaultValue: { value: 'NA', label: 'Not Applicable' },
      items: [
        { value: 'NA', label: 'Not Applicable' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: 'H', label: 'H' },
        { value: 'I', label: 'I' },
        { value: 'J', label: 'J' },
        { value: 'K', label: 'K' },
        { value: 'L', label: 'L' },
        { value: 'M', label: 'M' },
      ]
    }
  }, {
    id: 'W9.TIN.1',
    name: 'tintype',
    questionText: 'preQualifyingQuestionnaire.W9.TIN.1.questionText',
    style: Style.Card,
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'W9.TIN.3',
      condition: DynamicUpdateCondition.Is,
      expectedValue: 0,
      action: DynamicUpdateAction.DisableAndClear,
      conditionMet: true
    },
    setsTinInputFormat: true,
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: '1', label: 'SSN - Social Security Number' },
      items: [
        { value: 1, label: 'Social Security Number (SSN) or ITIN' },
        { value: 2, label: 'Employer Identification Number (EIN)' }
      ],
      itemsTinFormats: [
        'SSN', 'EIN'
      ]
    }
  }, {
    id: 'W9.TIN.2',
    name: 'tin',
    info: helpText.usTin,
    questionText: 'preQualifyingQuestionnaire.W9.TIN.2.questionText',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'W9.TIN.3',
      condition: DynamicUpdateCondition.Is,
      expectedValue: 0,
      action: DynamicUpdateAction.DisableAndClear,
      conditionMet: false
    },
    inputs: {
      type: InputType.TinField,
      fields: [
        { placeholder: 'REPLACE WITH TIN INPUT', required: true }
      ]
    },
    errorMessage: 'Please provide a TIN'
  }, {
    id: 'W9.TIN.3',
    name: 'appliedFor',
    questionText: 'preQualifyingQuestionnaire.W9.TIN.3.questionText',
    style: Style.Collapsible,
    collapsibleHeaderText: 'More TIN Options',
    group: 'Tax Identification Number (TIN)',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    }
  }, {
    id: 'W9.Signer.1',
    name: 'signername',
    info: helpText.signerName,
    questionText: 'preQualifyingQuestionnaire.W9.Signer.1.questionText',
    style: Style.Card,
    group: 'Signer Details',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Signer Name', required: true }
      ]
    },
    errorMessage: 'Required: Signer name is required.'
  }, {
    id: 'W9.Signer.2.Individual',
    name: 'capacityField',
    info: helpText.capacity,
    questionText: 'preQualifyingQuestionnaire.W9.Signer.2.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'W9.FTC.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: '1',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: false
    },
    complexCapacityContraint: {
      signerNameId: 'W9.Signer.1',
      givenNameId: ['W9.NAME.1'],
      expectedValue: 'Signing on Own Behalf'
    },
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
      items: [
        { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
        { value: 'Conservator', label: 'Conservator' },
        { value: 'Custodian for Minor Child', label: 'Custodian for Minor Child' },
        { value: 'Father', label: 'Father' },
        { value: 'Guardian', label: 'Guardian' },
        { value: 'Mother', label: 'Mother' },
        { value: 'Power of Attorney', label: 'Power of Attorney' },
        { value: 'Attorney in Fact', label: 'Attorney in Fact' },
        { value: 'Authorized Signer', label: 'Authorized Signer' },
        { value: 'Other', label: 'Other' },
      ]
    },
    errorMessage: 'Capacity is required when name and signer name do not match.'
  }, {
    id: 'W9.Signer.2.NotIndividual',
    name: 'capacityField',
    questionText: 'preQualifyingQuestionnaire.W9.Signer.2.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'W9.FTC.1',
      condition: DynamicUpdateCondition.Is,
      expectedValue: '1',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: 'Conservator', label: 'Conservator' },
      items: [
        { value: 'Conservator', label: 'Conservator' },
        { value: 'Authorized Signer', label: 'Authorized Signer' },
        { value: 'Secretary', label: 'Secretary' },
        { value: 'Controlling Person', label: 'Controlling Person' },
        { value: 'Attorney in Fact', label: 'Attorney in Fact' },
        { value: 'Power of Attorney', label: 'Power of Attorney' },
        { value: 'Chief Executive Officer (CEO)', label: 'Chief Executive Officer (CEO)' },
        { value: 'Chief Financial Officer (CFO)', label: 'Chief Financial Officer (CFO)' },
        { value: 'Chief Operating Officer (COO)', label: 'Chief Operating Officer (COO)' },
        { value: 'Chief Compliance Officer (CCO)', label: 'Chief Compliance Officer (CCO)' },
        { value: 'Director', label: 'Director' },
        { value: 'Other', label: 'Other' }
      ]
    }
  }, {
    id: 'W9.Signer.3.Individual',
    name: 'capacityFieldOther',
    questionText: 'preQualifyingQuestionnaire.W9.Signer.3.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'W9.Signer.2.Individual',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Capacity', required: true }
      ]
    },
    errorMessage: 'Please provide the capacity in which you are acting.'
  }, {
    id: 'W9.Signer.3.NotIndividual',
    name: 'capacityFieldOther',
    questionText: 'preQualifyingQuestionnaire.W9.Signer.3.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'W9.Signer.2.NotIndividual',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Capacity', required: true }
      ]
    },
    errorMessage: 'Please provide the capacity in which you are acting.'
  }, {
    id: 'W9.Signer.5',
    name: 'subjectToBackupWhd',
    questionText: 'preQualifyingQuestionnaire.W9.Signer.5.questionText',
    questionTextIsHtml: true,
    style: Style.Collapsible,
    collapsibleHeaderText: 'Additional Certifications',
    group: 'Signer Details',
    answer: false,
    isAnswered: true,
    inputs: {
      type: InputType.Checkbox
    }
  }
];

export default w9Questions;
